import {
	INSPECTION_VALUE_TYPES,
	InspectionTemplateColumn,
} from "@/shared/models/Inspection";
import DeleteIcon from "@mui/icons-material/Delete";
import {
	Autocomplete,
	Grid2,
	IconButton,
	MenuItem,
	TextField,
} from "@mui/material";
import { filterGroupNames } from "../utils/columnGroups";

type Props = {
	column: InspectionTemplateColumn;
	groupNames: string[];
	disabled: boolean;
	onChange: (changes: Partial<InspectionTemplateColumn>) => void;
	onGroupPicked: (groupName: string | null) => void;
	onGroupSettled: () => void;
	onRemove: () => void;
};

export const TemplateColumnRow = ({
	column,
	groupNames,
	disabled,
	onChange,
	onGroupPicked,
	onGroupSettled,
	onRemove,
}: Props) => (
	<Grid2 container size={{ xs: 12 }} spacing={1} alignItems="center">
		<Grid2 size={{ md: 4, xs: 12 }}>
			<Autocomplete
				freeSolo
				options={groupNames}
				filterOptions={filterGroupNames}
				value={column.GroupName ?? ""}
				inputValue={column.GroupName ?? ""}
				disabled={disabled}
				size="small"
				onInputChange={(_event, value) =>
					onChange({ GroupName: value === "" ? null : value })
				}
				// Picking a group from the list is a decision, so the column moves under it right
				// away. Typed text still settles on blur, or the rows would jump on every key.
				onChange={(_event, value) => {
					const groupName = typeof value === "string" ? value.trim() : "";
					onGroupPicked(groupName === "" ? null : groupName);
				}}
				onBlur={onGroupSettled}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Group"
						size="small"
						autoComplete="off"
					/>
				)}
			/>
		</Grid2>
		<Grid2 size={{ md: 4, xs: 12 }}>
			<TextField
				label="Label"
				required
				value={column.ColumnLabel}
				disabled={disabled}
				fullWidth
				size="small"
				autoComplete="off"
				onChange={(event) => onChange({ ColumnLabel: event.target.value })}
			/>
		</Grid2>
		<Grid2 size={{ md: 3, xs: 12 }}>
			<TextField
				select
				label="Type"
				value={column.ValueTypeCode}
				disabled={disabled}
				fullWidth
				size="small"
				onChange={(event) =>
					onChange({
						ValueTypeCode: event.target
							.value as InspectionTemplateColumn["ValueTypeCode"],
					})
				}
			>
				{INSPECTION_VALUE_TYPES.map((option) => (
					<MenuItem key={option.code} value={option.code}>
						{option.label}
					</MenuItem>
				))}
			</TextField>
		</Grid2>
		<Grid2 size="auto">
			<IconButton
				size="small"
				title="Remove"
				disabled={disabled}
				onClick={onRemove}
			>
				<DeleteIcon fontSize="small" color="secondary" />
			</IconButton>
		</Grid2>
	</Grid2>
);
